import { Injectable, ErrorHandler } from '@angular/core';

@Injectable({
  providedIn: 'root'
})
export class ErrorHandlerService extends ErrorHandler {

  constructor(
    //private monitoringService: AppInsightsMonitoringService        
  ) {
    super();
  }

  override handleError =(error: Error) => {
    // this.monitoringService.logException(error); // Manually log exception
  }

}
